import { render, staticRenderFns } from "./ClinicIncomeReport.vue?vue&type=template&id=0134d002&scoped=true"
import script from "./ClinicIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134d002",
  null
  
)

export default component.exports